import { Curve } from './Curve.js';
import { Vector3 } from '../../Vector3.js';
import { _Math } from '../../Math.js';
import type { Serializer, Deserializer } from '../../../utils/Serialization.js';
/**
 * The cubic-bezier curve object is used to help drawing curves in 3D space.
 */
export class CubicBezierCurve3D extends Curve<Vector3> {
    isCubicBezierCurve3D = true;
    v0: Vector3;
    v1: Vector3;
    v2: Vector3;
    v3: Vector3;

    constructor(v0?: Vector3, v1?: Vector3, v2?: Vector3, v3?: Vector3) {
        super();
        this.type = 'CubicBezierCurve3D';

        this.v0 = v0 || new Vector3();
        this.v1 = v1 || new Vector3();
        this.v2 = v2 || new Vector3();
        this.v3 = v3 || new Vector3();
    }

    serialize(ctx: Serializer) {
        ctx.puts<CubicBezierCurve3D>(['v0', 'v1', 'v2', 'v3']);
    }

    deserialize(ctx: Deserializer) {
        ctx.reads<CubicBezierCurve3D>(['v0', 'v1', 'v2', 'v3']);
    }

    className(): string {
        return 'CubicBezierCurve3D';
    }

    getPoint(t: number, optionalTarget?: Vector3): Vector3 {
        const point = optionalTarget || new Vector3();
        const v0 = this.v0;
        const v1 = this.v1;
        const v2 = this.v2;
        const v3 = this.v3;

        point.set(
            _Math.CubicBezier(t, v0.x, v1.x, v2.x, v3.x),
            _Math.CubicBezier(t, v0.y, v1.y, v2.y, v3.y),
            _Math.CubicBezier(t, v0.z, v1.z, v2.z, v3.z),
        );
        return point;
    }

    clone() {
        return new CubicBezierCurve3D().copy(this);
    }

    copy(source: CubicBezierCurve3D) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }

    toJSON(): any {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }

    fromJSON(json: any) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
